<template>
  <div style="width:100%">
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-list>
            <template v-for="(item, index) in items">
              <v-subheader v-if="item.header" :key="index">{{ item.header }}</v-subheader>

              <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>

              <v-list-tile v-else :key="index" avatar ripple>
                <v-list-tile-avatar>
                  <i class="material-icons" style="font-size:35px">{{item.avatar}}</i>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="item.title"
                    style="white-space:normal; height:fit-content;"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.owner"></v-list-tile-sub-title>
                  <v-list-tile-sub-title v-html="item.email"></v-list-tile-sub-title>
                  <v-list-tile-sub-title v-html="item.phone_number"></v-list-tile-sub-title>

                  <v-list-tile-sub-title v-html="item.location"></v-list-tile-sub-title>
                  <v-list-tile-sub-title v-html="item.created"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <div>
              <p class="description">{{this.description}}</p>
            </div>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "admin-chat-detail",
  props: {
    chat: Object
  },
  data() {
    return {
      showDescription: false,
      showHistory: false,
      description: this.chat.description,
      items: [
        {
          header: `Issue Report`,
          is_service: false
        },
        {
          avatar: "account_circle",
          owner: this.chat.owner,
          email: "test@gmail.com",
          phone_number: "123-456-6789",
          history: "test test test",
          is_service: false
        },
        { divider: true, inset: true, is_service: false },
        {
          avatar: "description",
          location: `Location: ${this.chat.location}`,
          created: ` Created: ${moment(this.chat.created).format(
            "MMMM Do YYYY"
          )}`,
          is_service: false
        },
        { divider: true, inset: true, is_service: false }
      ]
    };
  }
};
</script>

<style scoped>
p {
  padding: 0px 20px 0px 30px;
  text-align: left;
}
</style>


